import { isBrowser } from "../common/utils";
class WarkMark {
  constructor(config = {}) {
    this.config = {
      isRemove: false,
      container: document.body,
      width: "300px",
      height: "200px",
      textAlign: "center",
      textBaseline: "middle",
      font: "20px Microsoft Yahei",
      fillStyle: "rgba(184, 184, 184, 0.20)",
      content: "请勿外传",
      rotate: "30",
      zIndex: 1000,
      maxWidth: 180,
      lineHeight: 16,
      ...config,
    };
  }

  static getInstance(config = {}) {
    if (!this.instance) {
      // 把服务端情况的处理转移到内部判断
      if (isBrowser) {
        this.instance = new WarkMark(config);
      } else {
        this.instance = {
          init: function () {},
          removeWM: function () {},
          setConfigs: function () {},
        };
      }
    }
    return this.instance;
  }

  //更改配置
  setConfigs(configs = {}) {
    this.config = {
      ...this.config,
      ...configs,
    };
  }

  //初始化水印
  init(configs = {}) {
    this.config = {
      ...this.config,
      ...configs,
      isRemove: false,
    };
    this.extendCanvasWrapText();
    this.createWarkmark();
  }

  //绘制水印
  createWarkmark() {
    const {
      textAlign,
      textBaseline,
      font,
      fillStyle,
      rotate,
      container,
      zIndex,
      content,
      width,
      height,
      maxWidth,
      lineHeight,
      isRemove,
    } = this.config;
    const canvas = document.createElement("canvas");

    canvas.setAttribute("width", width);
    canvas.setAttribute("height", height);
    const ctx = canvas.getContext("2d");

    ctx.textAlign = textAlign;
    ctx.textBaseline = textBaseline;
    ctx.font = font;
    ctx.fillStyle = fillStyle;
    ctx.rotate((Math.PI / 180) * rotate);
    ctx.wrapText(content, parseFloat(width) / 2, parseFloat(height) / 2, maxWidth, lineHeight);
    // ctx.fillText(content, parseFloat(width) / 2, parseFloat(height) / 2);

    const base64Url = canvas.toDataURL();
    const __wm = document.querySelector(".__wm");

    const watermarkDiv = __wm || document.createElement("div");
    const styleStr = `
      position:absolute;
      top:0;
      left:0;
      width:100%;
      height:100%;
      z-index:${zIndex};
      pointer-events:none;
      background-repeat:repeat;
      background-image:url("${base64Url}")`;

    watermarkDiv.setAttribute("style", styleStr);
    watermarkDiv.classList.add("__wm");

    if (!__wm) {
      container.style.position = "relative";
      container.insertBefore(watermarkDiv, container.firstChild);
    }

    const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    if (MutationObserver) {
      let mo = new MutationObserver(() => {
        const __wm = document.querySelector(".__wm");
        if (isRemove) {
          mo.disconnect();
          mo = null;
          this.removeWM();
          return;
        }
        // 只在__wm元素变动才重新调用 __canvasWM
        if ((__wm && __wm.getAttribute("style") !== styleStr) || !__wm) {
          // 避免一直触发
          mo.disconnect();
          mo = null;
          !isRemove && this.init(this.config);
        }
      });

      mo.observe(container, {
        attributes: true,
        subtree: true,
        childList: true,
      });
    }
  }

  //扩展CanvasRenderingContext2D原生方法
  extendCanvasWrapText() {
    // ----------------------  扩展canvas支持换行  ---------------------
    CanvasRenderingContext2D.prototype.wrapText = function (text, x, y, maxWidth, lineHeight) {
      if (typeof text !== "string" || typeof x !== "number" || typeof y !== "number") {
        return;
      }

      var context = this;
      var canvas = context.canvas;

      if (typeof maxWidth === "undefined") {
        maxWidth = (canvas && canvas.width) || 300;
      }
      if (typeof lineHeight === "undefined") {
        lineHeight =
          (canvas && parseInt(window.getComputedStyle(canvas).lineHeight)) ||
          parseInt(window.getComputedStyle(document.body).lineHeight);
      }

      // 字符分隔为数组
      var arrText = text.split("");
      var line = "";

      for (var n = 0; n < arrText.length; n++) {
        var testLine = line + arrText[n];
        var metrics = context.measureText(testLine);
        var testWidth = metrics.width;
        if (testWidth > maxWidth && n > 0) {
          context.fillText(line, x, y);
          line = arrText[n];
          y += lineHeight;
        } else {
          line = testLine;
        }
      }
      context.fillText(line, x, y);
    };
  }

  //删除水印
  removeWM() {
    let findWm = document.querySelector(".__wm");
    if (findWm) {
      findWm.parentNode.removeChild(findWm);
      this.config.isRemove = true;
    }
  }
}
export default WarkMark.getInstance();
